module.exports = __webpack_public_path__ + "img/mind_element_attchment.c139ca4b.png";